export const DEMO_LABELS = {
    gender: {
      1: "Women",
      2: "Men",
    },
    age: {
      1: "18–34",
      2: "35–64",
      3: "65+",
    },
    education: {
      1: "Degree",
      2: "No degree",
    },
    ethnicity: {
      1: "White",
      2: "Non White",
    },
    party: {
      1: "Conservative",
      2: "Labour",
      3: "Reform",
      4: "Lib Dem",
      5: "Green",
      6: "SNP",
      7: "Plaid Cymru",
      8: "Independent/Other",
      9: "Non-voter",
    },
    // NOTE: there is deliberately no `segment` entry here. Segment codes are
    // only meaningful relative to a question's schema — 4 is "Nostalgic
    // Populists" under `tracking` but "Octopus Energy" under `energy` — so a
    // flat code→label map here would silently mislabel non-tracking questions.
    // Use segmentLabel(schema, code) from ./segmentConfig instead.
  };
  
